import { createFileRoute, redirect } from '@tanstack/react-router'

// The Campaigns + Feed-layout split was flattened into Content + Layout. `/marketing` now lands on
// the Content list; Layout is its own top-level nav item.
export const Route = createFileRoute('/_authenticated/_general/marketing/')({
	beforeLoad: () => {
		throw redirect({ to: '/marketing/content' })
	}
})
